import React, { useEffect, useState } from 'react'
import { useHistory } from "react-router-dom"

import Button from "@mui/material/Button/Button"
import { AiOutlineMenu, AiOutlineHeart } from "react-icons/ai"
import { IoWalletOutline, IoFlashOutline } from "react-icons/io5"
import { IoMdFingerPrint, } from "react-icons/io"
import { GrFormClose } from "react-icons/gr"
import { AiOutlineCompass } from "react-icons/ai"
import { GiSpeedBoat } from "react-icons/gi"
import { AiOutlineTool } from "react-icons/ai"
import { RiGalleryLine, RiDiscordFill } from "react-icons/ri"
import { BsBook, BsStars } from "react-icons/bs"

import Box from '@mui/material/Box';
import SwipeableDrawer from '@mui/material/SwipeableDrawer';

import Dis from "../../assets/images/dis.svg"
import Insta from "../../assets/images/insta.svg"
import Twitter from "../../assets/images/twitter.svg"
import OpenSea from "../../assets/images/openSea.svg"
import Logo from "../../assets/images/logo2.svg"
import Wallet from "../../assets/images/WalletSvg"

import "./Header.scss"


const Header = () => {
    const history = useHistory()

    const [state, setState] = React.useState({
        right: false,
    });
    const [hide, setHide] = useState(false)

    const toggleDrawer = (anchor, open) => (event) => {
        setState({ ...state, [anchor]: open });
    };


    const goToLink = (li) => {
        history.push(`/${li}`)
        setState({ right: false })
    }

    useEffect(() => {
        if (history.location.pathname == "/dashboard") {
            setHide(true)
        } else {
            setHide(false)
        }
    }, [history.location.pathname])

    const list = (anchor) => (
        <Box
            sx={{ width: anchor === 'top' || anchor === 'bottom' ? 'auto' : 250 }}
            role="presentation"
            onClick={toggleDrawer(anchor, false)}
            onKeyDown={toggleDrawer(anchor, false)}
        >
            <div className='slider_container'>
                <div className="title">
                    <img src={Logo} alt="ERROR" />
                    <p> Metaverse Marauders </p>
                    <Button className='closebtn' onClick={toggleDrawer("right", false)}> <GrFormClose /> </Button>
                </div>
                <div className="listdata">
                    <div className="pointer itm" onClick={() => goToLink("collection")} >
                        <AiOutlineCompass /> <p> Explore Collection </p>
                    </div>
                    <div className="pointer itm" onClick={() => goToLink("#")} >
                        <GiSpeedBoat /> <p> View in Opensea </p>
                    </div>
                    <div className="pointer itm" onClick={() => goToLink("sandaga")} >
                        <BsStars /> <p> Sandaga Project </p>
                    </div>
                    <div className="pointer itm" onClick={() => goToLink("#utilities")} >
                        <IoFlashOutline /> <p> Utilities </p>
                    </div>
                    <div className="pointer itm" onClick={() => goToLink("species")} >
                        <IoMdFingerPrint /> <p> 12 Species </p>
                    </div>
                    <div className="pointer itm" onClick={() => goToLink("#team")} >
                        <AiOutlineHeart /> <p> Team </p>
                    </div>
                    <div className="pointer itm" onClick={() => goToLink("known-facts")} >
                        <BsBook /> <p> Known facts </p>
                    </div>
                    <div className="pointer itm" onClick={() => goToLink("#")} >
                        <RiDiscordFill /> <p> Discord Leaderboards </p>
                    </div>
                    <div className="pointer itm" onClick={() => goToLink("kits")} >
                        <RiGalleryLine /> <p> Marauders Kits </p>
                    </div>
                    {/* <div className="pointer itm" onClick={()=> goToLink("")} >
                        <AiOutlineTool /> <p> Make your Marauder </p>
                    </div> */}
                    <div className="pointer vbtn" onClick={() => goToLink("#")} >
                        <IoWalletOutline /> <p> Connect Wallet </p>
                    </div>
                </div>

                <div className="slider_social">
                    <img src={Dis} alt="ERROR" /> <img src={Twitter} alt="ERROR" /> <img src={OpenSea} alt="ERROR" /> <img src={Insta} alt="ERROR" />
                </div>

            </div>
        </Box>
    );



    return (
        <>
            <div className="header_container" style={{ display: hide ? "none" : null }}>
                <div className="heading"> <p> NEXT PUBLIC SALE COMING SOON </p> </div>
                <div className="navb">
                    <div className="social">
                        <img src={Dis} alt="ERROR" /> <img src={Twitter} alt="ERROR" /> <img src={OpenSea} alt="ERROR" />
                        <p style={{ marginLeft: "1rem", color:"#0FFFF7" }}> FR </p> <p style={{color:"#0FFFF7"}}> EN </p>
                    </div>
                    <div style={{ cursor: "pointer" }} className="logo" onClick={() => history.push('/')}> <img src={Logo} alt="ERROR" /> </div>
                    <div className="options">
                        <Button className='mbtn' > Explore </Button> <Button className='mbtn2'> <IoWalletOutline /> </Button>
                        <Button className='mbtn2' onClick={toggleDrawer("right", true)}> <AiOutlineMenu /> </Button>
                        <div>
                            <SwipeableDrawer
                                anchor="right"
                                open={state["right"]}
                                onClose={toggleDrawer("right", false)}
                                onOpen={toggleDrawer("right", true)}
                            >
                                {list("right")}
                            </SwipeableDrawer>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Header
